/**
 * Simplified mobile utilities for NLFX Cable Builder
 */

// Basic mobile detection
export const isMobile = () => {
  return window.innerWidth <= 768;
};

// Basic touch detection
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

// Simple mobile optimization
export const getMobileOptimizations = () => {
  return {
    isMobile: isMobile(),
    isTouch: isTouchDevice(),
    // Basic mobile settings
    touchTargetSize: 44, // minimum touch target size in pixels
    preventZoom: true,
    enableSwipe: true
  };
};

// Simple image loading for mobile
export const loadImageSimple = (img, src) => {
  if (img && src) {
    img.src = src;
  }
};

// Basic error handling
export const handleMobileError = (error, context = '') => {
  console.warn(`Mobile issue in ${context}:`, error);
  return false;
};

export default {
  isMobile,
  isTouchDevice,
  getMobileOptimizations,
  loadImageSimple,
  handleMobileError
};
